import { HeroModule } from './HeroModule'
export default HeroModule
